var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('ConfigTemplateCard',{attrs:{"layouts":_vm.layouts,"variables":_vm.variables,"columnOptions":_vm.columns,"defaultTemplate":_vm.defaultTemplate},on:{"afterSave":_vm.afterSave}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }